import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=6965ba38&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=6965ba38&prod&scoped=true&lang=css"
import style1 from "./Category.vue?vue&type=style&index=1&id=6965ba38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965ba38",
  null
  
)

export default component.exports